import { render, staticRenderFns } from "./PrintAthaPage.vue?vue&type=template&id=9b4ac744&scoped=true"
import script from "./PrintAthaPage.vue?vue&type=script&lang=js"
export * from "./PrintAthaPage.vue?vue&type=script&lang=js"
import style0 from "./PrintAthaPage.vue?vue&type=style&index=0&id=9b4ac744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4ac744",
  null
  
)

export default component.exports